import { useContext } from "react"
import Select from "../../../components/Select/Select"
import { StaticDataContext } from "../../../views/signup-flow/SignupFormPage/SignupFormPage"
import { Option } from "../../../services/ntuc/userService/staticData"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

function RaceSelectField(props: FormFieldProps<Option>) {
    const staticData = useContext(StaticDataContext)
    const options = staticData ? staticData.race : []

    return (
        <Select
            {...props}
            label="race"
            options={options}
        />
    )
}

export default RaceSelectField
